import React from 'react';
import PropTypes from 'prop-types';
import QuoteView from '../../../quotes/view/quoteView';
import { withRouter } from 'react-router-dom';

const AttachmentPoint = ({ attachmentPoint, multiple }) => {
  if (!attachmentPoint.couplerDecisionLabel) {
    return null;
  }
  return (
    <div>
      <br />
      <div className="row">
        <div className="col">
          <div className="text-white font-weight-bold">{`LUGGING SELECTION${
            multiple ? ` (${attachmentPoint.name})` : ''
          }`}</div>
        </div>
      </div>
      <hr className="mt-1 mb-1" />
      <div className="row mb-0">
        <div className="col">
          <span>{attachmentPoint.couplerDecisionLabel}</span>
        </div>
      </div>
      {attachmentPoint.oemThumbMountDescription && (
        <div className="row mb-0">
          <div className="col-sm-12">
            {attachmentPoint.oemThumbMountDescription}
          </div>
        </div>
      )}
    </div>
  );
};

class MachineInformationComponent extends React.PureComponent {
  static propTypes = {
    quote: PropTypes.instanceOf(QuoteView).isRequired,
  };

  edit = () => {
    this.props.history.push(`/quotes/edit/${this.props.quote.id}/review`);
  };

  render() {
    const { quote } = this.props;
    const { machine } = quote;
    return (
      <div className="card mb-3 box-shadow machine-info flex-fill">
        <div className="card-body">
          <h6 className="card-title text-center">Machine Information</h6>
          {machine.make && (
            <div className="row">
              <div className="col-sm-12">
                {machine.make}
                &nbsp;
                {machine.model}
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-sm-12">
              <div>{machine.carrierName}</div>
              <div>
                {machine.weightClassLabel} ({machine.weightClassDescription})
              </div>
            </div>
          </div>
          {quote.attachmentPoints.map((x) => (
            <AttachmentPoint
              key={x.name}
              attachmentPoint={x}
              multiple={machine.supportsMultipleAttachmentPoints}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default withRouter(MachineInformationComponent);
